import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';

import Avatar from "../../../ui/Avatar/Avatar";

import "./ClientItem.scss";

import { formatPhone } from "../../../../methods";

class ClientItem extends Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
  };

  render() {
    const { client } = this.props;


    const link = `/consultant/${client.consultant_id}`;

    return (
      <div className='row client'>
        <div className="ava">
          <Avatar avatar={client.avatar} />
        </div>
        <div className="cols-wrap">
          <div className="col name">{client.name} {client.surname}</div>
          <div className="col phone"><a href={`tel:${client.phone}`}>{formatPhone(client.phone)}</a></div>
          <div className="col email">
            <a href={`mailto:${client.email}`}>{client.email}</a>
          </div>
          <div className="col address">{client.address}</div>
          <div className="col date">{moment(client.created_at).format('DD.MM.YYYY')}</div>
          <div className="col consult-id">
            <Link to={link}>{client.consultant_id}</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default ClientItem;
